import { useEffect, useState } from 'react'

/**
 * #392 round 3 — true while the CSS media `query` matches, following the browser's change events (a rotation,
 * a resized window). Where window.matchMedia is missing (jsdom, very old browsers) it answers `fallback`.
 */
export function useMediaQuery(query: string, fallback = false): boolean {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  const [matches, setMatches] = useState(() => (supported ? window.matchMedia(query).matches : fallback))

  useEffect(() => {
    if (!supported) return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query, supported])

  return matches
}
